import { configFetch as fetch } from '@laigu/utils';

export const getEnterpriseApi = () => {
  return fetch({
    url: '/enterprise',
    method: 'get'
  });
};

export const updateEnterpriseApi = data => {
  return fetch({
    url: '/enterprise',
    method: 'put',
    data
  });
};
